import axios from "axios";
import { Button, Text } from "components";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
const arr = [
  {
    id: 1,
    name: "Item 1",
    quantity: 1,
    costPrice: 100,
    packaging: "Box",
    code: "I001",
    providedCode: "P001",
    hsnCode: "1234",
    sacCode: "5678",
    salesOrderQty: 50,
    remainingQty: 20,
    stockQty: 30,
    sgst: 9,
    cgst: 9,
    igst: 18,
    description: "Sample item description",
    selected: false,
  },
  {
    id: 2,
    name: "Item 2",
    quantity: 2,
    costPrice: 150,
    packaging: "Packet",
    code: "I002",
    providedCode: "P002",
    hsnCode: "5678",
    sacCode: "1234",
    salesOrderQty: 60,
    remainingQty: 25,
    stockQty: 35,
    sgst: 5,
    cgst: 5,
    igst: 10,
    description: "Another item description",
    selected: false,
  },
  {
    id: 3,
    name: "Item 3",
    quantity: 3,
    costPrice: 200,
    packaging: "Carton",
    code: "I003",
    providedCode: "P003",
    hsnCode: "9101",
    sacCode: "1121",
    salesOrderQty: 40,
    remainingQty: 15,
    stockQty: 25,
    sgst: 6,
    cgst: 6,
    igst: 12,
    description: "Yet another item",
    selected: false,
  },
  {
    id: 4,
    name: "Item 4",
    quantity: 4,
    costPrice: 250,
    packaging: "Crate",
    code: "I004",
    providedCode: "P004",
    hsnCode: "3141",
    sacCode: "5161",
    salesOrderQty: 70,
    remainingQty: 30,
    stockQty: 50,
    sgst: 7,
    cgst: 7,
    igst: 14,
    description: "Special product",
    selected: false,
  },
  {
    id: 5,
    name: "Item 5",
    quantity: 5,
    costPrice: 300,
    packaging: "Bag",
    code: "I005",
    providedCode: "P005",
    hsnCode: "7181",
    sacCode: "9202",
    salesOrderQty: 80,
    remainingQty: 35,
    stockQty: 40,
    sgst: 8,
    cgst: 8,
    igst: 16,
    description: "High-quality item",
    selected: false,
  },
];

function DebitNoteItemsAdd() {
  const [items, setItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [visible, setvisible] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  let navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const company_purchase_order_id = location.state?.company_purchase_order_id;
  console.log(company_purchase_order_id);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    if (company_purchase_order_id) {
      getAllPurchaseOrderItems();
    } else {
      console.error(
        "company_purchase_order_id is not available in location state."
      );
    }
  }, [company_purchase_order_id]);

  const obj = { company_purchase_order_id: company_purchase_order_id };
  const getAllPurchaseOrderItems = () => {
    axios
      .post("/api/purple-fusion/companypurchaseorderitems/get", obj, headers)
      .then((response) => {
        setItems(response.data);
        console.log(response.data);
        // setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Calculate item-related fields dynamically
  const calculateValues = (item) => {
    const itemAmount = Number(item.quantity) * Number(item.cost_price);
    const sgstAmount = (item.sgst_percentage / 100) * itemAmount;
    const cgstAmount = (item.cgst_percentage / 100) * itemAmount;
    const igstAmount = (item.igst_percentage / 100) * itemAmount;
    const totalTax = sgstAmount + cgstAmount + igstAmount;
    const totalAmount = itemAmount + totalTax;

    return {
      itemAmount,
      sgstAmount,
      cgstAmount,
      igstAmount,
      totalTax,
      totalAmount,
    };
  };

  const filteredItems = items.filter(
    (item) =>
      item?.item_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.code_op.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleItemChange = (id, field, value) => {
    const updatedItems = items.map((item) =>
      item.id === id ? { ...item, [field]: value } : item
    );
    setItems(updatedItems);

    // Auto-check "Select All" if all filtered items are selected
    if (field === "selected") {
      const filtered = updatedItems.filter((item) =>
        item?.item_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      const allSelected =
        filtered.length > 0 && filtered.every((i) => i.selected);
      setSelectAll(allSelected);
    }
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    const updatedItems = items.map((item) =>
      item.item_name.toLowerCase().includes(searchTerm.toLowerCase())
        ? { ...item, selected: newSelectAll }
        : item
    );
    setItems(updatedItems);
  };

  const handleSave = () => {
    const selectedItems = items
      .filter((item) => item.selected)
      .map((item) => ({
        ...item,
        debit_note_id: id, // Adding credit note ID to each selected item
      }));
    console.log(selectedItems);
    axios
      .post("/api/purple-fusion/debitnoteitem/create", selectedItems, headers)
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setvisible(false);
                navigate(`/debitnote/item/${id}`, {
                  state: {
                    company_purchase_order_id: company_purchase_order_id,
                  },
                });
              },
            })
          : toast.error(message, {
              autoClose: 2000,
              onClose: () => {},
            });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const calculateTotalFooterValues = () => {
    const selectedItems = items.filter((item) => item.selected);

    let totalQty = 0;
    let totalItemAmount = 0;
    let totalSGST = 0;
    let totalCGST = 0;
    let totalIGST = 0;
    let totalTax = 0;
    let grandTotal = 0;

    selectedItems.forEach((item) => {
      const itemAmount = Number(item.quantity) * Number(item.cost_price);
      const sgst = (item.sgst_percentage / 100) * itemAmount;
      const cgst = (item.cgst_percentage / 100) * itemAmount;
      const igst = (item.igst_percentage / 100) * itemAmount;
      const tax = sgst + cgst + igst;
      const total = itemAmount + tax;

      totalQty += Number(item.quantity);
      totalItemAmount += itemAmount;
      totalSGST += sgst;
      totalCGST += cgst;
      totalIGST += igst;
      totalTax += tax;
      grandTotal += total;
    });

    return {
      totalQty,
      totalItemAmount,
      totalSGST,
      totalCGST,
      totalIGST,
      totalTax,
      grandTotal,
    };
  };

  const customStyles = {
    content: {
      width: "95%",
      height: "95%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };
  return (
    <>
      <Modal isOpen={visible} style={customStyles}>
        <div className="">
          <ToastContainer />
          <div className="flex flex-row items-center justify-start my-4 ">
            <div className="flex flex-row  items-start justify-between w-full ">
              <Text
                className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px]"
                size="txtInterMedium24"
              >
                Debit Note / Debit Note Item
              </Text>
            </div>
            <div className="flex flex-row items-center justify-end ml-auto top-2 ">
              <Button
                className="cursor-pointer font-medium mb-1.5 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]  active:scale-90 transition-transform duration-200"
                shape="round"
                color="blue_A700"
                size="base"
                variant="fill"
                // type="submit"
                onClick={handleSave}
              >
                Save
              </Button>
              <Button
                className="cursor-pointer font-medium mb-3 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]"
                shape="round"
                color="white"
                size="base"
                variant="fill"
                type="button"
                onClick={() => {
                  setvisible(false);
                  navigate(`/debitnote/item/${id}`, {
                    state: {
                      company_purchase_order_id: company_purchase_order_id,
                    },
                  });
                }}
              >
                ╳
              </Button>
            </div>
          </div>
          <div className="mb-2">
            <input
              type="text"
              placeholder="Search item name..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setSelectAll(false); // reset select all when searching
              }}
              className="p-2 border border-gray-300 rounded w-1/3 text-xs"
            />
          </div>
          <div className="overflow-x-auto min-h-[50vh] border-2">
            <table className="w-full border-collapse border border-gray-200 text-sm">
              <thead className="bg-gray-100">
                <tr className="text-left text-gray-700">
                  <th className="px-2 py-3">
                    {searchTerm === "" && (
                      <input
                        type="checkbox"
                        className="cursor-pointer rounded-md"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    )}
                  </th>
                  <th className="px-2 py-3">Item Name</th>
                  <th className="px-2 py-3">Quantity</th>
                  <th className="px-2 py-3">Cost Price</th>
                  <th className="px-2 py-3">Code</th>
                  <th className="px-2 py-3">Provided Code</th>
                  <th className="px-2 py-3">HSN Code</th>
                  <th className="px-2 py-3">SAC Code</th>
                  <th className="px-2 py-3">Item Amount</th>
                  <th className="px-2 py-3">SGST %</th>
                  <th className="px-2 py-3">CGST %</th>
                  <th className="px-2 py-3">IGST %</th>
                  <th className="px-2 py-3">SGST Amount</th>
                  <th className="px-2 py-3">CGST Amount</th>
                  <th className="px-2 py-3">IGST Amount</th>
                  <th className="px-2 py-3">Total Tax</th>
                  <th className="px-2 py-3">Total Amount</th>
                  <th className="px-2 py-3">Item Description</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((item) => {
                  const {
                    itemAmount,
                    sgstAmount,
                    cgstAmount,
                    igstAmount,
                    totalTax,
                    totalAmount,
                  } = calculateValues(item);

                  return (
                    <tr
                      key={item.id}
                      className="hover:bg-gray-50 text-xs border-2"
                    >
                      <td className="px-2 py-3 text-center">
                        <input
                          type="checkbox"
                          className="cursor-pointer rounded-md"
                          checked={item.selected}
                          onChange={() =>
                            handleItemChange(
                              item.id,
                              "selected",
                              !item.selected
                            )
                          }
                        />
                      </td>
                      <td className="px-2 py-3">{item.item_name}</td>
                      <td className="px-2 py-3">
                        <input
                          type="number"
                          className="w-20 p-1 border rounded-md text-center text-xs"
                          value={item.quantity || ""}
                          onChange={(e) =>
                            handleItemChange(
                              item.id,
                              "quantity",
                              parseFloat(e.target.value) || 0
                            )
                          }
                        />
                      </td>
                      <td className="px-2 py-3">
                        <input
                          type="number"
                          className="w-20 p-1 border rounded-md text-center text-xs"
                          value={item?.cost_price || ""}
                          onChange={(e) =>
                            handleItemChange(
                              item.id,
                              "cost_price",
                              parseFloat(e.target.value) || 0
                            )
                          }
                        />
                      </td>
                      <td className="px-2 py-3">{item.code}</td>
                      <td className="px-2 py-3">{item.code_op}</td>
                      <td className="px-2 py-3">{item.hsn_code}</td>
                      <td className="px-2 py-3">{item.sac_code}</td>
                      <td className="px-2 py-3">
                        {itemAmount.toFixed(2) || 0}
                      </td>
                      <td className="px-2 py-3">{item.sgst_percentage}%</td>
                      <td className="px-2 py-3">{item.cgst_percentage}%</td>
                      <td className="px-2 py-3">{item.igst_percentage}%</td>
                      <td className="px-2 py-3">{sgstAmount.toFixed(2)}</td>
                      <td className="px-2 py-3">{cgstAmount.toFixed(2)}</td>
                      <td className="px-2 py-3">{igstAmount.toFixed(2)}</td>
                      <td className="px-2 py-3">{totalTax.toFixed(2)}</td>
                      <td className="px-2 py-3">{totalAmount.toFixed(2)}</td>
                      <td className="px-2 py-3">{item.item_description}</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="bg-gray-100 font-semibold text-gray-800 sticky bottom-0 z-10">
                {(() => {
                  const {
                    totalQty,
                    totalItemAmount,
                    totalSGST,
                    totalCGST,
                    totalIGST,
                    totalTax,
                    grandTotal,
                  } = calculateTotalFooterValues();

                  return (
                    <tr className="text-xs border-t-2 border-gray-300">
                      <td className="px-2 py-2 text-center"></td>{" "}
                      {/* Checkbox column */}
                      <td className="px-2 py-2 text-right">Total</td>{" "}
                      {/* Item Name */}
                      <td className="px-2 py-2">{totalQty}</td> {/* Quantity */}
                      <td className="px-2 py-2">
                        {totalItemAmount.toFixed(2)}
                      </td>{" "}
                      {/* Cost Price */}
                      <td className="px-2 py-2"></td> {/* Code */}
                      <td className="px-2 py-2"></td> {/* Provided Code */}
                      <td className="px-2 py-2"></td> {/* HSN Code */}
                      <td className="px-2 py-2"></td> {/* SAC Code */}
                      <td className="px-2 py-2">
                        {totalItemAmount.toFixed(2)}
                      </td>{" "}
                      {/* Item Amount */}
                      <td className="px-2 py-2"></td> {/* SGST % */}
                      <td className="px-2 py-2"></td> {/* CGST % */}
                      <td className="px-2 py-2"></td> {/* IGST % */}
                      <td className="px-2 py-2">{totalSGST.toFixed(2)}</td>{" "}
                      {/* SGST Amount */}
                      <td className="px-2 py-2">{totalCGST.toFixed(2)}</td>{" "}
                      {/* CGST Amount */}
                      <td className="px-2 py-2">{totalIGST.toFixed(2)}</td>{" "}
                      {/* IGST Amount */}
                      <td className="px-2 py-2">{totalTax.toFixed(2)}</td>{" "}
                      {/* Total Tax */}
                      <td className="px-2 py-2">
                        {grandTotal.toFixed(2)}
                      </td>{" "}
                      {/* Total Amount */}
                      <td className="px-2 py-2"></td> {/* Item Description */}
                    </tr>
                  );
                })()}
              </tfoot>
            </table>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default DebitNoteItemsAdd;
